export function buildMenuTree(list, pid) {
  let tree = [];

  list.forEach((item) => {
    if (item.pid === pid) {
      const children = buildMenuTree(list, item.id);

      let data = { ...item };
      if (children && children.length > 0) {
        data.children = children;
      }

      tree.push(data);
    }
  });

  return tree;
}

export function findPID(list, pid) {
  const result = [];
  let findID = pid;

  while (list.find((item) => item.id === findID)) {
    const item = list.find((item) => item.id === findID);
    result.unshift(item.id);
    findID = item.pid;
  }
  return result;
}
